export enum TaskAttachmentIcon {
  'PDF' = 'assets/media/svg/files/pdf.svg',
  'PNG' = 'assets/media/svg/files/png.svg',
  'JPG' = 'assets/media/svg/files/jpg.svg',
  'JPEG' = 'assets/media/svg/files/jpg.svg',
  'CSV' = 'assets/media/svg/files/csv.svg',
  'TXT' = 'assets/media/svg/files/txt.svg',
  'DOC' = 'assets/media/svg/files/doc.svg',
  'DOCX' = 'assets/media/svg/files/doc.svg',
  'PPT' = 'assets/media/svg/files/ppt.svg',
  'HTML' = 'assets/media/svg/files/html.svg',
  'XLS' = 'assets/media/svg/files/xls.svg',
  'OTHER' = 'assets/media/svg/files/document.svg',
}
